<template>
  <div class="h-full bg-[#12121c]/90 text-white">
    <h1>hi</h1>
  </div>
</template>